import { TranslateHelper } from './../../_helpers/translate-helper';
import { ChangeDetectorRef, Component, Inject, Input, OnChanges, OnDestroy, OnInit, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, UrlSerializer } from '@angular/router';
import { AdvancedSearchService } from '@app/_services';
import { HomepageService } from '@app/_services/homepage.service';
import { SharedService } from '@app/_services/shared.service';
import * as _ from 'lodash';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { Support } from '@app/_helpers';
import { Observable, Subject } from 'rxjs';
import { isPlatformBrowser, NgClass, NgFor, NgIf } from '@angular/common';
import { ShopSidebarService } from '@app/_services/shop-sidebar.service';
import { fromMatchMedia } from '@shared/functions/rxjs/fromMatchMedia';
import { TranslateModule } from '@ngx-translate/core';
import { RangeInputComponent } from '../../_components/inputs/range-input/range-input.component';
import { TextInputComponent } from '../../_components/inputs/text-input/text-input.component';
import { CheckboxInputComponent } from '../../_components/inputs/checkbox-input/checkbox-input.component';
import { SelectButtonComponent } from '../../_components/inputs/select-button/select-button.component';
import { SelectSearchComponent } from '../../_components/inputs/select-search/select-search.component';
import { SelectInputComponent } from '../../_components/inputs/select-input/select-input.component';
import { IconComponent } from '../../shared/components/icon/icon.component';
import { ExtendedModule } from '@angular/flex-layout/extended';

@Component({
    selector: 'app-widget-advanced-search',
    templateUrl: './widget-advanced-search.component.html',
    styleUrls: ['./widget-advanced-search.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgClass, ExtendedModule, IconComponent, FormsModule, ReactiveFormsModule, NgFor, NgIf, SelectInputComponent, SelectSearchComponent, SelectButtonComponent, CheckboxInputComponent, TextInputComponent, RangeInputComponent, TranslateModule]
})
export class WidgetAdvancedSearchComponent implements OnInit, OnDestroy, OnChanges {
    constructor(
        private fb: UntypedFormBuilder,
        private advancedSearchService: AdvancedSearchService,
        private homepageService: HomepageService,
        private router: Router,
        private route: ActivatedRoute,
        private sharedService: SharedService,
        private urlSerializer: UrlSerializer,
        public translateHelper: TranslateHelper,
        public sidebar: ShopSidebarService,
        private cdr: ChangeDetectorRef,
        @Inject(PLATFORM_ID)
        private platformId: any
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        this.searchInfoClone = _.cloneDeep(this.searchInfo);
        this.buildForm();
    }

    @Input() searchInfo;
    @Input() blockId;
    @Input() type;
    @Input() subtypeId;
    @Input() companyId;
    @Input() offcanvas: 'always' | 'mobile' = 'mobile';
    categoryIds;
    priceForm = this.fb.group({
        min: null,
        max: null
    });
    private destroy$: Subject<void> = new Subject();
    sector;
    form = this.fb.group({
        properties: this.fb.array([])
    });;
    icon = 'add';
    formObservable$: any;
    formValues;
    isOpen = false;
    searchInfoClone;
    ngOnInit(): void {

        this.categoryIds = this.searchInfo.categoryIds;
        this.searchInfoClone = _.cloneDeep(this.searchInfo);
        this.sharedService.page$.subscribe(page => (this.sector = page));
        this.buildForm();

        this.sidebar.isOpen$.pipe(
            takeUntil(this.destroy$)
        ).subscribe(isOpen => {
            if (isOpen) {
                this.open();
            } else {
                this.close();
            }
        });

        if (isPlatformBrowser(this.platformId)) {
            fromMatchMedia('(max-width: 991px)').pipe(takeUntil(this.destroy$)).subscribe(media => {
                if (this.offcanvas === 'mobile' && this.isOpen && !media.matches) {
                    this.close();
                }
            });
        }
    }

    ngOnDestroy(): void {
        this.close();
        this.destroy$.next();
        this.destroy$.complete();
    }

    opened() {
        this.icon = 'remove';
    }
    closed() {
        this.icon = 'add';
    }

    buildForm(reset?) {


        this.propertyControl.clear();
        this.searchInfoClone = _.cloneDeep(this.searchInfo);

        /*    this.form = this.fb.group({
               properties: this.fb.array([])
           }); */


        let qParams: any = {};

        _.forEach(this.route.snapshot.queryParams, (params, key) => {
            _.set(qParams, key, params);
        })


        if (qParams.minPrice && qParams.minPrice != "null") {
            this.priceForm.get("min").patchValue(reset ? null : qParams.minPrice);
        }
        if (qParams.maxPrice && qParams.maxPrice != "null") {
            this.priceForm.get("max").patchValue(reset ? null : qParams.maxPrice);
        }

        if (qParams.type) {
            this.type = qParams.type;
        }

        if (qParams.companyId) {
            this.companyId = qParams.companyId;
        }


        _.forEach(this.searchInfo?.rows, row => {
            _.forEach(row.blocks, (block, key) => {
                let property = _.find(qParams?.properties, ["propertyId", block.propertyId]);
                let combineProperty = _.find(qParams?.properties, ["propertyId", block.combinePropertyId]);
                if (reset) {
                    delete property?.value;
                    delete combineProperty?.value;
                }

                let group = this.fb.group({
                    propertyId: [block.propertyId],
                    combinePropertyId: [block.combinePropertyId],
                    value: [reset ? null : property?.value],
                    combinePropertyValue: [reset ? null : combineProperty?.value],
                });

                if (block.property?.type == 'range' || property?.min || property?.max) {
                    group.addControl('min', new UntypedFormControl(reset ? null : property?.min));
                    group.addControl('max', new UntypedFormControl(reset ? null : property?.max));
                }

                this.propertyControl.push(
                    group
                );
                if (block.property?.type == 'price') {
                    this.priceForm.patchValue(block)
                }

            });
        });



        if (this.formValues) {
            _.forEach(this.formValues.properties, property => {
                let propertyIndex = _.findIndex(this.propertyControl.value, ["propertyId", property.propertyId]);

                this.propertyControl.at(propertyIndex).patchValue(property);
            })

        }

    }

    get propertyControl() {
        return this.form.get('properties') as UntypedFormArray;
    }

    checkOptions() {

        let params = {
            sector: this.sector,
            type: this.type,
            ...(this.type == 'company') ? { companyId: this.companyId } : {},
            ...(this.type == 'category') ? { categoryId: this.categoryIds } : {}
            // blockId: this.blockId
        };
        params = _.merge(params, this.form.value);

        this.advancedSearchService
            .getSearchInfo(params)
            .subscribe(response => {
                this.searchInfo = response.data;
                this.formValues = _.cloneDeep(this.form.value);
                this.buildForm();
            });
    }


    submit() {
        this.formValues = null;
        let params: any = {
            sector: this.sector,
            ...(this.type == 'company') ? { companyId: this.companyId } : {},
            /// blockId: this.blockId,
            subtypeId: this.subtypeId,
            type: this.type

        };

        let properties = [];
        _.forEach(this.form.value?.properties, element => {
            if ((element.value && element.value != "null") || element.min || element.max)
                properties.push({
                    propertyId: element.propertyId,
                    ...(element.value) ? { value: element.value } : [],
                    ...(element.min ? { min: element.min } : []),
                    ...(element.max ? { max: element.max } : [])
                });
            if (element.combinePropertyId) {
                properties.push({
                    propertyId: element.combinePropertyId,
                    ...(element.combinePropertyValue) ? { value: element.combinePropertyValue } : [],
                });
            }
            if (element.propertyId == 'price') {
                params.minPrice = this.priceForm.get('min').value;
                params.maxPrice = this.priceForm.get('max').value;
            }
        });

        let url = this.router.url.split("?")[0];

        if (!url.includes('search'))
            url = this.router.createUrlTree([url, 'search'], {
                relativeTo: this.route
            }).toString();
        params = _.merge(params, { properties: properties, categoryIds: this.categoryIds?.join(",") });            
        url += `?${Support.toQueryParams(params)}`;
        this.router.navigateByUrl(url);

        this.sidebar.close();
    }

    private open(): void {
        if (isPlatformBrowser(this.platformId)) {
            const bodyWidth = document.body.offsetWidth;

            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = (document.body.offsetWidth - bodyWidth) + 'px';
        }

        this.isOpen = true;
    }

    private close(): void {
        if (isPlatformBrowser(this.platformId)) {
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        }

        this.isOpen = false;
    }

    /*   kill() {
          this.propertyControl.clear();
          this.form.reset();
          this.searchInfo = _.cloneDeep(this.searchInfoClone);
      } */
    reset(): void {


        // this.searchInfo = _.cloneDeep(this.searchInfoClone);
        this.formValues = null;
        let qParams = this.route.snapshot.queryParams;
        this.propertyControl.clear();
        this.form.reset();

        setTimeout(() => {
            this.searchInfo = _.cloneDeep(this.searchInfoClone);
            this.buildForm(true);

            let params = {
                limit: qParams.limit || this.sharedService.paginations.limit,
                page: 1,
            };
            this.updateUrl(params);
        })


        //this.submit();

    }


    updateUrl(filterParams): any {
        const tree = this.router.parseUrl(this.router.url);
        tree.queryParams = this.getQueryParams(filterParams);

        if (this.route.snapshot.queryParams?.q)
            tree.queryParams.q = this.route.snapshot.queryParams.q;

        if (this.route.snapshot.queryParams?.categoryIds)
            tree.queryParams.categoryIds = this.route.snapshot.queryParams?.categoryIds;

        if (this.route.snapshot.queryParams?.companyId)
            tree.queryParams.companyId = this.route.snapshot.queryParams?.companyId;

        if (this.route.snapshot.queryParams?.sector)
            tree.queryParams.sector = this.route.snapshot.queryParams?.sector;

        if (this.route.snapshot.queryParams?.type)
            tree.queryParams.type = this.route.snapshot.queryParams?.type;

        if (this.route.snapshot.queryParams?.subTypeId)
            tree.queryParams.subTypeId = this.route.snapshot.queryParams?.subTypeId;


        if (tree.queryParams) {

            this.router.navigate(
                [],
                {
                    relativeTo: this.route,
                    queryParams: tree.queryParams,
                    queryParamsHandling: '',

                });
        }
        return tree.queryParams;
    }

    getQueryParams(params): any {
        let filterParams: any = {}
        if (params.page) {
            filterParams.page = params.page;
        }
        if (params.limit) {
            filterParams.limit = params.limit;
        }
        if (params.f) {
            _.forEach(params.f, (value, key) => {
                if (value && key !== 'price') {
                    filterParams["f[" + key + "]"] = value;
                } else if (value?.min && key === 'price') {
                    filterParams['f[price][min]'] = value.min;
                    filterParams['f[price][max]'] = value.max;

                }
            });
        }
        if (params.r) {
            _.forEach(params.r, (value, key) => {
                if (value) {
                    filterParams['r[' + key + ']'] = value;
                }
            })
        }
        return filterParams;
    }

}
